import __ from "web/Layout/Translations";

const getProductNoun = (count: number) => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return __("produkt");
  }

  if (
    lastDigit >= 2 &&
    lastDigit <= 4 &&
    (lastTwoDigits < 12 || lastTwoDigits > 14)
  ) {
    return __("produkty");
  }

  return __("produktów");
};

const getProductCountAccessibleText = (count: number) =>
  `${count} ${getProductNoun(count)}`;

export default getProductCountAccessibleText;
